import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { questionsQueryKeys } from './questionsQueryKeys';

const getQuestionImgPreview = async ({ questionId, fileName }) => {
  return await request.get(
    `/Question/preview`,
    { questionId, fileName },
    'При загрузке превью изображения для вопроса произошла ошибка',
    ''
  );
};

const useQuestionImgPreview = ({ id, questionId, fileName }, options) =>
  useQuery(
    questionsQueryKeys.questionImgPreview(id),
    () => getQuestionImgPreview({ questionId, fileName }),
    options
  );

export default useQuestionImgPreview;
